export default __webpack_public_path__ + "static/Launch-Day-Boat-716bea1f5c895c5020d4a2cd9c785167.jpg";